import { IconAccountGear, IconBroom, IconStar } from '../assets/DesignSystem/SVGComponents';
import { getConfigClassDisplayName, getCommentsFromEvidence, getStatusNameFromId } from '../utils/configurations';
import {
  TProductConfigResponse,
  CONFIG_STATUS_NAME,
  CONFIG_STATUS_NAME_COLOR,
  LS_ADDITIONAL_SERVICE_TYPE,
  CONFIG_CLASS_ID,
  CONFIG_STATUS_ID
} from '../types/product.configuration.types';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import { BordOneToneIcon } from 'components/NudosComponents';
import { CURRENCIES } from 'types/bussines';

export const getConfigurationDisplayElements = (configurationData: TProductConfigResponse) => {
  const { status, evidence, configClassId, configClassName } = configurationData;
  const comments = getCommentsFromEvidence(evidence);
  const statusWithDefault = getStatusNameFromId(status.statusId);
  const callToActionText = status.statusId === CONFIG_STATUS_ID.NOT_COMPLETED ? 'Ver motivos' : 'Ver';

  switch (configClassId) {
    case CONFIG_CLASS_ID.WIPING:
      return {
        text: LS_ADDITIONAL_SERVICE_TYPE.WIPING,
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconBroom className="iconBroom configurationIcon" />
      };
    case CONFIG_CLASS_ID.BASIC_CONFIGURATION:
      return {
        text: 'Conf. básica',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconAccountGear className="iconAccountGear configurationIcon" />
      };
    case CONFIG_CLASS_ID.CONFIG_AVANZADA:
      return {
        text: 'Conf. avanzada',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconStar className="iconStar configurationIcon" />
      };
    default:
      return {
        text: configClassName || getConfigClassDisplayName(configClassId),
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[CONFIG_STATUS_NAME.TO_COMPLETE],
        callToActionText,
        icon: <IconStar className="iconStar configurationIcon" />
      };
  }
};

export const getConfigurationDisplayElementsBord = (configurationData: TProductConfigResponse) => {
  const { status, evidence, configClassId, configClassName } = configurationData;
  const comments = getCommentsFromEvidence(evidence);

  const statusWithDefault = getStatusNameFromId(status.statusId);
  const callToActionText = status.statusId === CONFIG_STATUS_ID.NOT_COMPLETED ? 'Ver motivos' : 'Ver';

  const assignSpecificIcon = () => {
    if (!configClassId) return <BordOneToneIcon variant="star" customWidth="14px" stroke="#626C82" />;
    const variantGroups: [TbordOneToneIcon, CONFIG_CLASS_ID[]][] = [
      ['apple', [CONFIG_CLASS_ID.APPLE_CARE_PLUS, CONFIG_CLASS_ID.APPLE_CONFIGURATOR]],
      ['cpu', [CONFIG_CLASS_ID.MDM_ENROLLMENT]],
      ['hash', [CONFIG_CLASS_ID.HASH_ID]],
      ['atSign', [CONFIG_CLASS_ID.CREAR_ADMIN]],
      ['sliders', [CONFIG_CLASS_ID.ENCRIPTAR_BITLOCKER]],
      ['star', [CONFIG_CLASS_ID.CONFIG_AVANZADA, CONFIG_CLASS_ID.DIAGNOSTICO]],
      ['wiping', [CONFIG_CLASS_ID.WIPING]],
      ['shield', [CONFIG_CLASS_ID.GARANTIA_1_ANO, CONFIG_CLASS_ID.GARANTIA_3_ANOS]],
      ['laptopSettings', [CONFIG_CLASS_ID.DEP]]
    ];
    const variant = variantGroups.find(([, ids]) => ids.includes(configClassId))?.[0] ?? 'star';
    return <BordOneToneIcon stroke="#626C82" variant={variant} customWidth="14px" />;
  };

  switch (configClassId) {
    case CONFIG_CLASS_ID.WIPING:
      return {
        text: LS_ADDITIONAL_SERVICE_TYPE.WIPING,
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="wiping" customWidth="14px" stroke="#626C82" />
      };
    case CONFIG_CLASS_ID.BASIC_CONFIGURATION:
      return {
        text: 'Conf. básica',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="settings" customWidth="14px" stroke="#626C82" />
      };
    case CONFIG_CLASS_ID.CONFIG_AVANZADA:
      return {
        text: 'Conf. avanzada',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="star" customWidth="14px" stroke="#626C82" />
      };
    default:
      return {
        text: configClassName || 'Sin información',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[CONFIG_STATUS_NAME.TO_COMPLETE],
        callToActionText,
        icon: assignSpecificIcon()
      };
  }
};

export const paymentDateBlockedMessage = ({ customClassName }: { customClassName?: string }) => (
  <div className={customClassName}>
    No puedes configurar acuerdo <br /> de pago para pagos con <br /> tarjeta de crédito
  </div>
);

export const VOLATILE_CURRENCIES = [CURRENCIES.ARS, CURRENCIES.BRL];
